var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8109 6.20347C36.5869 5.32347 35.4989 4.60547 34.3909 4.60547H5.61085C4.50085 4.60547 3.41285 5.32347 3.19085 6.20347L2.78885 8.60547H37.2108L36.8109 6.20347ZM38.8249 10.6055H1.17485C1.01331 10.6056 0.853569 10.6394 0.705865 10.7048C0.558161 10.7703 0.425749 10.8658 0.317111 10.9854C0.208473 11.1049 0.126005 11.2459 0.074989 11.3991C0.0239729 11.5524 0.00553363 11.7147 0.0208524 11.8755L1.86685 35.2135C1.90363 35.5944 2.08089 35.9479 2.3641 36.2052C2.64732 36.4626 3.01619 36.6053 3.39885 36.6055H36.6008C36.9835 36.6053 37.3524 36.4626 37.6356 36.2052C37.9188 35.9479 38.0961 35.5944 38.1329 35.2135L39.9789 11.8755C39.9942 11.7147 39.9757 11.5524 39.9247 11.3991C39.8737 11.2459 39.7912 11.1049 39.6826 10.9854C39.574 10.8658 39.4415 10.7703 39.2938 10.7048C39.1461 10.6394 38.9864 10.6056 38.8249 10.6055ZM16.0009 28.6055V18.6055L24.7669 23.6055L16.0009 28.6055Z",
    fill: "url(#paint0_linear_5336_31217)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5336_31217",
    x1: -72.658,
    y1: -41.893,
    x2: 72.1028,
    y2: -74.2788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.297847,
    stopColor: "#009BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634591,
    stopColor: "#BC658D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreation);
export default __webpack_public_path__ + "static/media/creation.d1368c96d68876dc85c0df5275316d11.svg";
export { ForwardRef as ReactComponent };